export const LINK_YANDEX_YML_INSTRUCTIONS = 'https://yandex.ru/support/marketplace/ru/assortment/auto/yml?lang=ru';
export const LINK_YANDEX_MARKET_CABINET = 'https://partner.market.yandex.ru/';

/**
 * Ссылка на инструкцию по подключению Фулфилмент Яндекс Маркета
 */
export const LINK_YANDEX_MARKET_LAAS_INSTRUCTION = 'https://yandex.ru/support/kit/ru/integration/market/fby';

/**
 * Ссылка на инструкцию по подключению домена
 */
export const LINK_DOMAIN_INSTRUCTION = 'https://yandex.ru/support/kit/ru/domain/permanent';

/**
 * Ссылка на инструкцию по настройке почтовых уведомлений
 */
export const LINK_EMAIL_SETTINGS_INSTRUCTION = 'https://yandex.ru/support/kit/ru/settings/email';

/**
 * Ссылка на справку по автоматическим коллекциям
 */
export const LINK_AUTOMATIC_COLLECTIONS_INSTRUCTION =
    'https://yandex.ru/support/kit/ru/goods/collections/type/auto-coll';

export const LINK_PRICE_INDEX_INSTRUCTION = 'https://yandex.ru/support/kit/ru/goods/price';
export const LINK_PRICE_INDEX_NO_DATA_INSTRUCTION = `${LINK_PRICE_INDEX_INSTRUCTION}#no-data`;
